import { getPreSlaRequirementsAgreement } from '@/services/implementationmanagement.api';
import { formatDateToWrittenDate } from '@/helpers/dates';

export async function buildPreSlaRequirementsAgreement(taskId) {

    // Call identity verification API to get the status of the identity verification process
    var response = await getPreSlaRequirementsAgreement(taskId);

    if(response.status !== 200 || response.data === null || response.data === undefined) {
        console.error('Error fetching identity verification task');
        return null;
    }

    const task = response.data;
    

    const card = {
    id: task.taskId,
    title: task.taskName,
    subtitle: 'Review the agreements that have been identified for your company',
    progress: calculateProgress(task),
    subProgressMessage: '',
    status: task.taskStatus,
    route: '/tasks/pre-sla-requirements-agreement/' + task.taskId, 
    createdDate: new Date(task.createdDate)
  }
    
  return card 
}

function calculateProgress(task) {
    if (!task || !Array.isArray(task.individualChecks) || task.individualChecks.length === 0) {
        return 0;
    }
    const totalChecks = Array.isArray(task.individualChecks) ? task.individualChecks.length : 0;
    const inProgressChecks = totalChecks > 0
        ? task.individualChecks.filter(check => check.taskStatus === 'InProgress').length
        : 0;
    
    
    var progress = totalChecks > 0 ? Math.round((inProgressChecks / totalChecks) * 100) : 0;

    return (totalChecks === 1 && inProgressChecks === 1) ? 50 : progress;
}